// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { StringUtil } from 'utils/StringUtil';
import { RouteUtil } from 'utils/RouteUtil';
// eslint-disable-next-line
import styles from "./styles.scss";

type Header = {
  title: string,
  link: string,
};

type Props = {
  links: Array<Header>,
  history: Object,
  connectRoute: boolean,
  selected_link: Object,
};

const HeaderLinks = (props: Props) => {
  const {
    links,
    selectedLinkId,
    connectRoute,
    selected_link,
    sectionType,
    onGetInTouchClick = true,
    checkForCTAButton = true,
  } = props;

  const navigateToLink = (id, link) => {
    if (connectRoute) {
      const routeName = link;
      RouteUtil.setRouteChange(props, `/${routeName}`);
    } else selected_link(id, link);
  };
  const onProjectAnnouncementClick = urlSlug => {
    const redirectionURl = urlSlug;
    if (redirectionURl) {
      const matches =
        redirectionURl.includes('https') ||
        redirectionURl.includes('http') ||
        redirectionURl.toUpperCase().includes('https') ||
        redirectionURl.toLowerCase().includes('https');
      if (!matches) {
        RouteUtil.setRouteChange(props, redirectionURl);
      } else {
        window.location.assign(`${redirectionURl}`);
      }
    }
  };

  const checkAnnouncementURL = urlSlug => {
    if (checkForCTAButton === true && !urlSlug) onGetInTouchClick(true);
    else onProjectAnnouncementClick(urlSlug);
  };
  return (
    <ul className={'header-links-container'}>
      {links?.customLinks &&
        links?.customLinks.map((link, idx) => (
          <li key={idx} onClick={() => checkAnnouncementURL(link.link)}>
            {sectionType === 'features' ? (
              <a
                className={`info-link bold ${
                  selectedLinkId === link.id ? 'active-tab' : ''
                }`}
              >
                {link.name}
              </a>
            ) : (
              <a
                className={`info-link bold ${
                  selectedLinkId === link.id ? 'active-tab' : ''
                }`}
              >
                {link.name}
              </a>
            )}
          </li>
        ))}

    </ul>
  );
};

const headerLinks = withRouter(HeaderLinks);
export { headerLinks as HeaderLinks };
